import { cn } from '@workspace/lib/utils/cn';

export const Spinner = ({
  className,
  size = 'lg',
}: {
  className?: string;
  size?: 'sm' | 'lg';
}) => (
  <div className={cn('w-fit', className)}>
    <div
      className={
        size === 'lg'
          ? 'border-t-brand-blue animate-spin-loader size-20 rounded-full border-[6px] border-neutral-400'
          : 'border-t-brand-blue animate-spin-loader size-[42px] rounded-full border-[3px] border-neutral-400'
      }
      aria-hidden='true'
    />
  </div>
);
